module.exports = __webpack_public_path__ + "static/2012-header-8bfb9f6225a8a2799f4c27d14ab0aecc.jpg";